import React from 'react';
import { useHistory } from 'react-router-dom';

import PageTemplate from '../../../components/common/template/PageTemplate';
import { Text } from '../../../components/common/atom/Text';
import { Button } from '../../../components/common/atom/Button';
import styled from 'styled-components';
import * as PATH from '../../../lib/routes/path';
import { getCDNUrl } from '../../../lib/image/CDNUrl';

const HeRecordingPrivacyConsent = ({ match }) => {
  const { barcodeId } = match.params;
  const history = useHistory();

  const redirectToList = () => {
    // Redirect to the list with validated flag
    localStorage.setItem("he_recording_barcodeId", barcodeId);
    history.push(`${PATH.HE_RECORDING_BARCODE}/${barcodeId}/list`, { 
      validated: true 
    });
  }

  return (
    <PageTemplate title={PAGE_TITLE_RECORD}>
      <div style={{ marginBottom: '0.625rem' }}>
        <Text size={20} weight="bold" lineHeight={1.5}>소중한 첫 만남을 더욱 특별하게<br /></Text>
        <Text size={16} lineHeight={1.5}>클리어페이스는 입체초음파 영상을 선명하고 깨끗하게 처리하여, 아기의 첫 모습을 더욱 생생하게 만들어드립니다.</Text>
        <Image src={getCDNUrl("service", "babyface_he_img_1.png")} alt="클리어페이스 결과 이미지" />
        <Text size={20} weight="bold" lineHeight={1.5}>휴대폰으로 동영상 받아보기<br /></Text>
        <Text size={16} lineHeight={1.5}>
          병원에 저장된 아기의 초음파 동영상을 휴대폰으로 안전하게 다운로드할 수 있습니다.<br />
          <b style={{fontWeight: "bold"}}>&nbsp;• 미동의 시: 병원에만 보관 (30일 후 자동 삭제)</b>
        </Text>
      </div> 
      <PrivacyInfo>
        <b>초음파 동영상 수집, 제공 동의서</b><br />
        서비스 제공을 위해 아래의 개인정보를 수집, 이용 및 제공합니다.<br />
        <ul>
          <li>수집 항목: 디지털 동영상(초음파 영상)</li>
          <li>수집 및 이용 목적: 클리어페이스 저장 및 관련서비스 제공</li>
          <li>보유 및 이용 기간: 5년</li>
          <li>제3자 제공: 알레시오(주)(클리어페이스, 베이비페이스 운영사)</li>
        </ul>
      </PrivacyInfo>
      <div>
        <ConsentButton onClick={redirectToList}>
          동의하고 동영상 받기
        </ConsentButton>
      </div>
    </PageTemplate>
  );
}

export default React.memo(HeRecordingPrivacyConsent);

const PAGE_TITLE_RECORD = '초음파 동영상';

const Image = styled.img`
  display: block;
  margin: 1.5rem 1rem;
  width: calc(100% - 2rem);
`;

const PrivacyInfo = styled.div`
  margin-bottom: 1.5rem;
  padding: 5.5px 12px;
  background-color: #F2F4F6;
  color: #A7AEB9;
  font-size: 0.6875rem;
  line-height: 1.5;
  b {
    font-weight: 700;
    color: #666666;
  }

  ul {
    margin: 0;
    padding-inline-start: 1rem;
  }
  ul li {
    font-size: 0.6875rem;
    line-height: 1.5;
  }
`

const ConsentButton = styled(Button)`
  border-radius: 0.375rem;
  padding: 1rem;
  background: ${(props) => props.theme.color.orangePink};
`;
